import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { useCart } from '../contexts/CartContext';
import { imgSrc, gbp } from '../lib/shop';

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const soldOut = product.stock !== null && product.stock !== undefined && product.stock <= 0;

  const handleAdd = (e) => {
    e.preventDefault();
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/shop/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group flex flex-col bg-white rounded-2xl border-2 border-pink-50 overflow-hidden hover:border-pink-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
    >
      <div className="aspect-square bg-pink-50/40 overflow-hidden">
        <img
          src={imgSrc(product.image_url)}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <p className="text-xs uppercase tracking-wider text-pink-600 font-semibold mb-1">{product.category}</p>
        <h3 className="font-bold text-gray-900 text-lg leading-snug mb-2 line-clamp-2">{product.name}</h3>
        <p className="text-sm text-gray-600 line-clamp-2 mb-4 flex-1">{product.description}</p>
        <div className="flex items-center justify-between gap-3">
          <span className="text-xl font-bold text-gray-900" data-testid={`product-price-${product.slug}`}>{gbp(product.price)}</span>
          <Button
            size="sm"
            onClick={handleAdd}
            disabled={soldOut}
            data-testid={`add-to-cart-${product.slug}`}
            className="bg-pink-500 hover:bg-pink-600 text-white rounded-full"
          >
            <ShoppingCart className="w-4 h-4 mr-1" />
            {soldOut ? 'Sold out' : 'Add'}
          </Button>
        </div>
      </div>
    </Link>
  );
};
